var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chart',{staticClass:"flex-grow-1",staticStyle:{"height":"91vh"},attrs:{"option":_setup.option,"theme":'light-theme',"autoresize":"","multiple":""},on:{"geoselectchanged":_setup.link,"selectchanged":_setup.link}})
}
var staticRenderFns = []

export { render, staticRenderFns }